import { createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrl } from "../../../../boot";
import axios from "axios";

// get customers

export const getMappingListApi = createAsyncThunk("client/get-mappingMiddleware-list", async (data) => {
    const token = localStorage.getItem("authToken");
    try {
        const response = await axios.post(`${baseUrl}vancouverapis/admin/mappingMiddleware/api/v1/get-mappingMiddleware-list`, data, {
            headers: {
                "auth-token": token,
                "Content-Type": "application/json",
            },
        });

        console.log("response of maping list", response);
        return response;
    } catch (error) {
        console.error("Error fetching customers - ", error);
        throw error;
    }
});

//get count
export const getMappingCountApi = createAsyncThunk("client/mappingMiddleware-count", async (data) => {
    const token = localStorage.getItem("authToken");
    try {
        const response = await axios.get(`${baseUrl}vancouverapis/admin/mappingMiddleware/api/v1/mappingMiddleware-count`, {
            headers: {
                "auth-token": token,
                "Content-Type": "application/json",
            },
        });

        console.log("response of maping list", response);
        return response;
    } catch (error) {
        console.error("Error fetching customers - ", error);
        throw error;
    }
});

// import data for

export const importMappingMiddlewareApi = createAsyncThunk("client/import-csv-files", async (data) => {
    const token = localStorage.getItem("authToken");
    try {
        const response = await axios.post(`${baseUrl}vancouverapis//import-csv/api/v1/import-mapping-middleware`, data, {
            headers: {
                "auth-token": token,
                // Remove Content-Type to let browser set it automatically for FormData
            },
        });

        console.log("response of maping list", response);
        return response.data;
    } catch (error) {
        console.error("Error fetching customers - ", error);
        throw error;
    }
});

//  update mappingMiddleware

export const updateMappingMiddlewareApi = async (data) => {
    const token = localStorage.getItem("authToken");
    try {
        const response = await axios.put(`${baseUrl}vancouverapis/admin/mappingMiddleware/api/v1/update-mappingMiddleware/${data.ROWID}`, data, {
            headers: {
                "auth-token": token,
                "Content-Type": "application/json",
            },
        });
        console.log("response of maping list", response);
        return response
    } catch (error) {
        console.error("Error Updating mapping middleware - ", error);
        throw error;
    }
};

// delete mappingMiddleware

export const deleteMappingMiddlewareApi = async (data) => {
  const token = localStorage.getItem("authToken");
  try {
    const response = await axios.delete(`${baseUrl}vancouverapis/admin/mappingMiddleware/api/v1/delete-mappingMiddleware/${data}`, {
      headers: {
        "auth-token": token,
        "Content-Type": "application/json",
      },
    });
    console.log("response of maping list", response);
    return response
  } catch (error) {
    console.error("Error Deleting mapping middleware - ", error);
    throw error;
  }
};

// CREATE MAPLIST

export const createMappingMiddlewareApi = async (data) => {
    const token = localStorage.getItem("authToken");
    try {
        const response = await axios.post(`${baseUrl}vancouverapis/admin/mappingMiddleware/api/v1/create-mappingMiddleware`, data, {
            headers: {
                "auth-token": token,
                "Content-Type": "application/json",
            },
        });
        console.log("response of maping list", response);
        return response
    } catch (error) {
        console.error("Error Creating mapping middleware - ", error);
        throw error;
    }
};


